import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { isEmpty } from 'lodash/lang';
import { translate } from 'react-i18next';

import IdentificationForm from '../IdentificationForm/';
import ErrorMessage from '../../components/Messages/ErrorMessage';
import TimeSlotCard from '../../components/TimeSlotCard/';
import { transformReservationsToTimeSlot } from '../../util/helpers';

import './CancelReservationAsDiv.scss';
import BankSelection from '../../components/BankSelection';

class CancelReservationAsDiv extends Component {

  constructor(props) {
    super(props);
    this.handleFormInputChange = this.handleFormInputChange.bind(this);
    this.sendReservationCode = this.sendReservationCode.bind(this);
    this.confirmCancelling = this.confirmCancelling.bind(this);
    this.initialState = {
      formValues: {},
      sendReservationCodeButtonDisabled: true
    };
    this.state = this.initialState;
  }

  sendReservationCode(event) {
    event.preventDefault();
    this.props.fetchReservation(this.state.formValues.reservationCode);
  }

  handleFormInputChange(event) {
    const { id: fieldName, value } = event.target;
    this.setState({
      formValues: {
        ...this.state.formValues,
        [fieldName]: value
      }
    }, this.validateFields);
  }

  validateFields() {
    const { reservationCode } = this.state.formValues;
    const allFieldsValid = (reservationCode.length > 0);
    this.setState({ sendReservationCodeButtonDisabled: !allFieldsValid });
  }

  confirmCancelling() {
    this.props.cancelReservation(this.props.reservation.reservation);
  }

  render() {
    const {
      userIdentified, fetchingReservationError, reservation,
      reservationCancelled, cancellingReservationError, loginPolicyType, t
    } = this.props;

    let currentPhase;
    let textKey;

    if (!userIdentified) {
      const loginComponent = loginPolicyType === 'STRONG' ? (
        <div className={'intro-box intro-box-left container-fluid'}>
          <BankSelection showBackButton={false} />
        </div>
      ) : <IdentificationForm />;
      currentPhase = (
        <div className="text-center">
          <h2 className="test booking-phase-title">{t('cancelReservation.loginFirstTitle')}</h2>
          <hr />
          <div className="cancellation-body-div">
            <p>{t('cancelReservation.loginFirstText')}</p>
            { loginComponent }
          </div>
        </div>
      );
    } else if (isEmpty(reservation)) {
      currentPhase = (
        <div className="text-center">
          <h2 className="test booking-phase-title" tabIndex={0}>{t('cancelReservation.insertReservationCodeTitle')}</h2>
          <hr />
          <div className="cancellation-body-div">
            <form className="reservation-number-form" onSubmit={this.sendReservationCode}>
              <div className="form-input-group cancellation-reservation-form-div">
                <input
                  id="reservationCode"
                  type="text"
                  placeholder={t('cancelReservation.reservationCodePlaceholder')}
                  className="cancellation-reservation-code-input"
                  onChange={this.handleFormInputChange}
                />
              </div>
              <ErrorMessage isVisible={!isEmpty(fetchingReservationError)}>
                <strong>{t(`cancelReservation.${fetchingReservationError}`)}</strong>
                <p>{t('cancelReservation.checkReservationCodeMessage')}</p>
              </ErrorMessage>
              <Button
                className="action-btn center-block"
                type="submit"
                disabled={this.state.sendReservationCodeButtonDisabled}
              >
                {t('cancelReservation.searchForReservationButton')}
              </Button>
            </form>
          </div>
        </div>
      );
    } else if (!reservationCancelled) {
      console.log('Inserting unit', this.props.units, this.props.reservation.unit);
      currentPhase = (
        <div className="text-center">
          <h2 className="test booking-phase-title" tabIndex={0}>{t('cancelReservation.confirmCancellingTitle')}</h2>
          <hr />
          <div className="cancellation-body-div">
            <TimeSlotCard
              timeSlot={transformReservationsToTimeSlot(reservation, this.props.resources, t)}
              onClick={reservation.canBeCancelled ? this.confirmCancelling : null}
              disabled={!reservation.canBeCancelled}
              unit={this.props.units[this.props.reservation.unit]}
              actionElement={reservation.canBeCancelled ? <span className="time-slot-action-text">{t('cancelReservation.cancelButton')}</span> : <p />}
            />
            { !reservation.canBeCancelled &&
            <span>{t('cancelReservation.notCancelableReason')}</span>
            }
            <ErrorMessage isVisible={!isEmpty(cancellingReservationError)}>
              <strong>{t(`cancelReservation.${cancellingReservationError}`)}</strong>
            </ErrorMessage>
          </div>
        </div>
      );
    } else {
      textKey = this.props.reservationWasAlreadyCancelled ? 'alreadyCancelled' : 'reservationCancelledTitle';
      currentPhase = (
        <div className="reservation-cancelled-phase text-center">
          <div className="reservation-cancelled-actions">
            <h2 className="test booking-phase-title" tabIndex={0}>{t(`cancelReservation.${textKey}`)}</h2>
            <p>{t(`cancelReservation.reservationCancelledInfoText`)}</p>
            <hr />
            <div className="cancellation-body-div">
              <Button
                className="action-btn action-btn-logout"
                onClick={this.props.logout}
              >
                {t('logoutButton')}
              </Button>
              <Button
                className="action-btn action-btn-back"
                onClick={this.props.closeCancelReservationScreen}
              >
                {t('cancelReservation.backToBooking')}
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return currentPhase;
  }
}

CancelReservationAsDiv.propTypes = {
  userIdentified: PropTypes.bool.isRequired,
  fetchReservation: PropTypes.func.isRequired,
  fetchingReservationError: PropTypes.string,
  reservation: PropTypes.object,
  cancelReservation: PropTypes.func.isRequired,
  closeCancelReservationScreen: PropTypes.func.isRequired,
  cancellingReservationError: PropTypes.string,
  reservationCancelled: PropTypes.bool,
  reservationWasAlreadyCancelled: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  resources: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
  loginPolicyType: PropTypes.string,
  units: PropTypes.shape({})
};

CancelReservationAsDiv.defaultProps = {
  fetchingReservationError: '',
  reservation: {},
  cancellingReservationError: '',
  reservationCancelled: false,
  resources: {},
  units: {},
  user: {},
  reservationWasAlreadyCancelled: false,
  loginPolicyType: 'ONLY_SSN'
};


export default translate(['booking'])(CancelReservationAsDiv);



// WEBPACK FOOTER //
// ./src/containers/CancelReservationAsDiv/CancelReservationAsDiv.jsx